<template>
  <div id="brands-content" class="container">
    <div class="section">
      <h1 class="title-underline">Brands Using {{ $root.domainName }}</h1>
      <hr>
      <div class="brand-group" v-for="(group, index) in brandIcons" :key="index">
        <div class="brand well" v-for="(brand, index) in group" :key="index" data-aos-delay="100" data-aos-duration="500"
          data-aos-once="true" data-aos="flip-down">
          <img :src="brand.logo" :alt="brand.alt" height="150px">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import brandIcons from '../../../../data/brandIcons.json';

export default {
  name: 'brands',

  data() {
    return {
      brandIcons: brandIcons.allBrands[0] || {}
    }
  }
};
</script>

<style scoped lang="scss">
#brands-content {

  .section {
    hr {
      border-top: 2px solid #393939;
    }

    .brand-group {
      display: grid;
      grid-auto-flow: column;
      grid-gap: calc(2.6vmin);
      padding: 3% 0;

      .brand {
        display: inline-block;
        margin: 0 2%;

      }

      img {
        border-radius: 5%;
        height: 150px;
        width: 100%;
      }

      .well {
        padding: 0;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .section {
      .brand-group {
        grid-auto-flow: row;
      }
    }
  }
}
</style>